/**
 * @file    num2cn
 * @authors KevinChan (chj@8cuo.net)
 * @date    2025/3/12 15:40:12
 */
export default function (num) {
  if (typeof num !== 'number') {
    return false
  }
  const chnNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const units = ['', '十', '百', '千'];
  const sections = ['', '万', '亿', '万亿'];
  let result = '';
  let isNegative = false;

  if (num < 0) {
    isNegative = true;
    num = Math.abs(num);
  }

  if (num === 0) return '零';

  let zeroFlag = false;
  let sectionPos = 0;

  while (num > 0) {
    let section = num % 10000;
    num = Math.floor(num / 10000);
    let sectionStr = '';
    let unitIndex = 0;

    while (section > 0) {
      const digit = section % 10;
      section = Math.floor(section / 10);

      if (digit !== 0) {
        sectionStr = chnNums[digit] + units[unitIndex] + sectionStr;
        zeroFlag = false;
      } else if (!zeroFlag) {
        sectionStr = chnNums[digit] + sectionStr;
        zeroFlag = true;
      }
      unitIndex++;
    }

    if (sectionStr !== '') {
      result = sectionStr + sections[sectionPos] + result;
      if (result.startsWith('一十')) {
        result = result.slice(1);
      }
      zeroFlag = false;
    }
    sectionPos++;
  }

  // 拼接符号并优化零处理‌:ml-citation{ref="5,6" data="citationList"}
  return (isNegative ? '负' : '') +
    result.replace(/零+/g, '零')
      .replace(/零+([万亿])/g, '$1')
      .replace(/零$/, '');
}



// WEBPACK FOOTER //
// ./src/utils/num2cn.js